import "./CollapsibleCardComp.css";
import { defineComponent as b, toRefs as g, openBlock as l, createElementBlock as n, createElementVNode as o, normalizeClass as c, toDisplayString as i, unref as a, createVNode as t, createCommentVNode as r, withCtx as p, createBlock as m, renderSlot as y } from "vue";
import { CollapsibleComp as v } from "./CollapsibleComp.js";
import { IconComp as d } from "./IconComp.js";
import { ButtonComp as B } from "./ButtonComp.js";
import { _ as M } from "./_plugin-vue_export-helper.dad06003.js";
const N = { class: "collapsible-card" }, V = { class: "card-header-right" }, w = { class: "card-body" }, E = /* @__PURE__ */ b({
  __name: "CollapsibleCardComp",
  props: {
    headline: { default: "" },
    collapsed: { type: Boolean, default: !1 },
    headerColor: { default: "dark" },
    statusMessage: { default: "" },
    statusColor: { default: "" }
  },
  emits: ["click"],
  setup(u, { emit: f }) {
    const _ = u, { headline: C, collapsed: s } = g(_), k = f, h = () => {
      k("click");
    };
    return (e, I) => (l(), n("div", N, [
      o("div", {
        class: c(["card-header", e.headerColor])
      }, [
        o("span", null, i(a(C)), 1),
        o("span", V, [
          e.statusMessage ? (l(), n("span", {
            key: 0,
            class: c(["card-header-status", e.statusColor])
          }, [
            t(d, {
              icon: "warning_small",
              color: e.statusColor === "red" ? "#d65432" : "#ffc107"
            }, null, 8, ["color"]),
            o("span", null, i(e.statusMessage), 1)
          ], 2)) : r("", !0),
          t(B, {
            onClick: h,
            blank: ""
          }, {
            default: p(() => [
              a(s) ? (l(), m(d, {
                key: 0,
                icon: "expand_more_small",
                color: e.headerColor === "dark" ? "#fff" : "#3b3f4a"
              }, null, 8, ["color"])) : r("", !0),
              a(s) ? r("", !0) : (l(), m(d, {
                key: 1,
                icon: "keyboard_control_key_small",
                color: e.headerColor === "dark" ? "#fff" : "#3b3f4a"
              }, null, 8, ["color"]))
            ]),
            _: 1
          })
        ])
      ], 2),
      o("div", w, [
        t(v, { toggle: a(s) }, {
          default: p(() => [
            y(e.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["toggle"])
      ])
    ]));
  }
});
const j = /* @__PURE__ */ M(E, [["__scopeId", "data-v-385c8b6b"]]);
export {
  j as CollapsibleCardComp
};
//# sourceMappingURL=CollapsibleCardComp.js.map
